import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * TrackingScripts Component
 * 
 * Handles route change tracking for analytics platforms.
 * All tracking scripts (GHL, FB Pixel, Google Analytics) are loaded directly in index.html
 * This component just ensures they track page views on React Router navigation.
 */
const TrackingScripts = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes for Google Analytics
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
    
    // Track page views for Facebook Pixel
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'PageView');
    }
    
    console.log('📊 Page view tracked:', location.pathname);
  }, [location]); // Runs on every route change

  return null;
};

export default TrackingScripts;
